import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

export function useCashFlow({ from, to, granularity, scenario = 'median' }) {
  const scopeKey = useScopeKey();
  const enabled = !!(from && to && granularity) && scopeKey !== 'loading';
  return useQuery({
    queryKey: ['cash-flow', scopeKey, from, to, granularity, scenario],
    queryFn: () =>
      api.get(`/cash-flow?from=${from}&to=${to}&granularity=${granularity}&scenario=${scenario}`),
    staleTime: 60_000,
    enabled,
  });
}
